export default __webpack_public_path__ + "static/Guides_2-938c6ed1ee81dcd56967c11a5a9e2f37.webp";